import {defineAccessControlledResource, GroupAccessRule} from '@igp/shared/access-control';

import {groups} from '@access-control';

export const keycloakLogsPageResource = defineAccessControlledResource({
    name: 'KeycloakLogsPageResource',
    rules: new GroupAccessRule([groups.adminsGroup]),
});
